<div class="sidebar included">
	<app-sidebar-header [title]="INDRA_getGroupLabel()"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable" #sidebar__body>
		<app-flight-route [flight]="flightRouteInput"></app-flight-route>
		<div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
		<div class="sidebar-flight-text">
			<h2 class="title-h2">{{'whatsIncludedSidebars.premiumCustomerCentre.titles.premiumCustomer' | ibeadmin: 'sync'}}</h2>
			<ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getAllWarnings(flight.idFlight.toString(), ancillaryGroup)">
				<app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'" [classes]="'alert-sidebar top-gap bottom-gap'"
				 [title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
				 + ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">
					<div message><span *ngIf="statusCode !== 46">{{'whatsIncludedSidebars.general.texts.useInAnotherFlight' | ibeadmin:'sync'}}</span>
						<a class="link" href="{{'whatsIncludedSidebars.general.texts.contactLink' | ibeadmin:'sync'}}" target="_blank"  [attr.aria-label]="'whatsIncludedSidebars.premiumCustomerCentre.aria.goRefund' | ibeadmin: 'sync'">
							{{'whatsIncludedSidebars.general.texts.contactTap' | ibeadmin:'sync'}}
						</a>
						{{'whatsIncludedSidebars.general.texts.moreInfo' | ibeadmin:'sync'}}
					</div>
				</app-notification>
			</ng-container>
			<div *ngFor="let passenger of passengers" class="border sidebar-flight-text ">
				<!-- fare related ancillaries for the passenger-->
				<div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax)" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
							</app-svg>
							<span class="bold">{{'whatsIncludedSidebars.premiumCustomerCentre.texts.at' | ibeadmin: 'sync'}} {{INDRA_printDepartureLocation()}} {{'whatsIncludedSidebars.premiumCustomerCentre.texts.Airport' | ibeadmin: 'sync'}}
							</span> {{'whatsIncludedSidebars.premiumCustomerCentre.texts.includedIn' | ibeadmin: 'sync'}} 
							<span class="capitalize">{{INDRA_printBrand()}}</span>.
						</p>
					</div>
				</div>
				<!-- tier benefits ancillaries for the passenger-->
				<div *ngIf="!INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax) && INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax)"
					class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
							</app-svg>
							<span class="bold">{{'whatsIncludedSidebars.premiumCustomerCentre.texts.at' | ibeadmin: 'sync'}} {{INDRA_printDepartureLocation()}} {{'whatsIncludedSidebars.premiumCustomerCentre.texts.Airport'
								| ibeadmin: 'sync'}}
							</span> {{'whatsIncludedSidebars.premiumCustomerCentre.texts.isA' | ibeadmin: 'sync'}} {{INDRA_getPassengerTierLabel(passenger)}}
							{{'whatsIncludedSidebars.premiumCustomerCentre.texts.benefit' | ibeadmin: 'sync'}}.
						</p>
					</div>
				</div>
				<!-- purchased ancillaries for the passenger-->
				<div *ngIf="INDRA_getAncillaryForPassenger(paxPurchaseFeatures, passenger.idPax)" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p *ngIf="!INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax) &&
							!INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax)" class="bold">{{INDRA_printPassengerName(passenger)}}
						</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="">
							<ng-container *ngIf="!INDRA_checkUnconfirmed(passenger)">
								<app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
							</ng-container>
							<ng-container *ngIf="INDRA_checkUnconfirmed(passenger)">
								<app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true"></app-svg>
							</ng-container>
							<span class="bold">{{'whatsIncludedSidebars.premiumCustomerCentre.texts.at' | ibeadmin: 'sync'}} {{INDRA_printDepartureLocation()}} {{'whatsIncludedSidebars.premiumCustomerCentre.texts.Airport'
								| ibeadmin: 'sync'}}</span>
						</p>
					</div>
				</div>
				<!-- no ancillaries for the passenger-->
				<div *ngIf="!INDRA_getAncillaryForPassenger(paxPurchaseFeatures, passenger.idPax) &&
					!INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax) &&
					!INDRA_getAncillaryForPassenger(paxTierBenefits, passenger.idPax)" class="grid no-padding">
					<div class="col-4 col-tp-4 col-p-12 no-padding">
						<p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
					</div>
					<div class="col-8 col-tp-8 col-p-12">
						<p class="col-8 col-tp-8 col-p-12">
							{{'whatsIncludedSidebars.premiumCustomerCentre.texts.notIncluded' | ibeadmin: 'sync'}}
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text border">
			<h2 class="title-h2">{{'whatsIncludedSidebars.premiumCustomerCentre.titles.cancellationRules' | ibeadmin: 'sync'}}</h2>
			<div class="grid">
				<div class="col-12">
					<ul>
						<li>{{'whatsIncludedSidebars.premiumCustomerCentre.texts.flammablesRule' | ibeadmin: 'sync'}};</li>
						<li>{{'whatsIncludedSidebars.premiumCustomerCentre.texts.explosivesRule' | ibeadmin: 'sync'}};</li>
						<li>{{'whatsIncludedSidebars.premiumCustomerCentre.texts.poisonsRule' | ibeadmin: 'sync'}};</li>
						<li>{{'whatsIncludedSidebars.premiumCustomerCentre.texts.pressurizedContainersRule' | ibeadmin: 'sync'}}</li>
					</ul>
				</div>
			</div>
		</div>
		<div class="sidebar-flight-text border">
			<p>
				<a class="link extras-feature__link" aria-label="Close dialog" (click)="INDRA_handleClose()" href="javascript:;" role="button">Close this window</a>
			</p>
		</div>
	</div>
	<div #sidebar__footer class="sidebar__footer "></div>
</div>
